import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="bg-f360-dark text-white pt-20 pb-10 px-4 sm:px-6 lg:px-8 text-center" data-id="element-116">
      <div className="max-w-[800px] mx-auto" data-id="element-117">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-extrabold mb-6 leading-tight" data-id="element-118">
          ⚽ FÚTBOL 360 — El sistema de planificación N°1
          <br className="hidden sm:block" data-id="element-119" /> para entrenadores de fútbol
          argentinos.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-f360-gold italic mb-12" data-id="element-120">
          "Porque preparar un buen entrenamiento no debería costarte todas las
          noches de la semana."
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mb-16" data-id="element-121">
          <a href="#precio" className="inline-flex items-center justify-center w-full sm:w-auto px-10 py-5 text-xl font-black text-f360-dark bg-f360-gold hover:bg-yellow-400 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-122">
            💪 QUIERO MI FÚTBOL 360 AHORA
          </a>
          <p className="mt-4 text-sm text-white/70 flex flex-wrap justify-center gap-3" data-id="element-123">
            <span data-id="element-124">🛡️ Garantía 7 días</span>
            <span className="hidden sm:inline" data-id="element-125">·</span>
            <span data-id="element-126">🔒 Pago seguro</span>
            <span className="hidden sm:inline" data-id="element-127">·</span>
            <span data-id="element-128">⚡ Acceso inmediato</span>
          </p>
        </motion.div>

        <div className="border-t border-white/10 pt-10" data-id="element-129">
          <p className="font-bold text-lg mb-4" data-id="element-130">⚽ FÚTBOL 360™</p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-white/80 mb-8 text-sm" data-id="element-131">
            <span data-id="element-132">📧 contacto@futbol360.com.ar</span>
            <span className="hidden sm:inline" data-id="element-133">·</span>
            <span data-id="element-134">📲 @futbol360.ar</span>
            <span className="hidden sm:inline" data-id="element-135">·</span>
            <span data-id="element-136">🌐 www.futbol360.ar</span>
          </div>
          <p className="text-xs text-white/50" data-id="element-137">
            © FÚTBOL 360™ 2025 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}